export function isApp() {
  const ua = navigator.userAgent;
  const isAndroid = /(Android);?[\s/]+([\d.]+)?/.test(ua);
  const isIpad = /(iPad).*OS\s([\d_]+)/.test(ua);
  const isIpod = /(iPod)(.*OS\s([\d_]+))?/.test(ua);
  const isIphone = !isIpad && /(iPhone\sOS)\s([\d_]+)/.test(ua);
  const isWechat = /micromessenger/i.test(ua);
  if (isWechat) return false;
  return isAndroid || isIpad || isIpod || isIphone;
}

/**
 * 获取当前运行环境
 * @returns {Object} { isApp, isBrowser, isWechat, isMiniProgram, isUniApp, envType }
 * envType: 'app' | 'browser' | 'wechat' | 'miniprogram'
 */
export function getEnv() {
  const ua = navigator.userAgent.toLowerCase();
  const isWechat = /micromessenger/i.test(ua);
  const isMiniProgram = ua.indexOf('miniprogram') > -1;
  const isUniApp = /uni-app/i.test(ua);
  
  // 判断是否在App的WebView中（通过uni-app标识或自定义标识）
  // uni-app 打包的App会在UA中带有 uni-app 标识
  const isInApp = isUniApp || (window.plus !== undefined) || (window.uni !== undefined);
  
  // 判断是否是纯浏览器环境
  const isBrowser = !isWechat && !isMiniProgram && !isInApp;
  
  // 环境类型
  let envType = 'browser';
  if (isMiniProgram) {
    envType = 'miniprogram';
  } else if (isWechat) {
    envType = 'wechat';
  } else if (isInApp) {
    envType = 'app';
  }
  
  return {
    isApp: isInApp,
    isBrowser,
    isWechat,
    isMiniProgram,
    isUniApp,
    envType
  };
}

/**
 * 获取签约回调地址
 * @param {string} path - 回调路径，如 '/my-center'
 * @param {string} appScheme - App的URL Scheme，如 'jiuyeduizhang'
 * @returns {string} 回调地址
 */
export function getSignRedirectUrl(path, appScheme = 'jiuyeduizhang') {
  const env = getEnv();
  
  if (env.envType === 'app') {
    // App环境：使用URL Scheme
    return `${appScheme}://${path.replace(/^\//, '')}`;
  } else if (env.envType === 'miniprogram') {
    // 小程序环境：返回小程序路径
    return path;
  } else {
    // 浏览器/微信H5环境：使用完整的H5地址
    return `${window.location.origin}/#${path}`;
  }
}

export function checkDevice() {
  const ua = navigator.userAgent;
  const isAndroid = /(Android);?[\s/]+([\d.]+)?/.test(ua);
  const isIpad = /(iPad).*OS\s([\d_]+)/.test(ua);
  const isIpod = /(iPod)(.*OS\s([\d_]+))?/.test(ua);
  const isIphone = !isIpad && /(iPhone\sOS)\s([\d_]+)/.test(ua);
  const isWechat = /micromessenger/i.test(ua);
  return {
    isAndroid,
    isIpad,
    isIpod,
    isIphone,
    isWechat
  };
}

// 判断是否是手机号
export function checkIsPhone(str) {
  var reg = /^0?1[3|4|5|6|7|8|9][0-9]\d{8}$/;
  return reg.test(str);
}
// 返回缩减地址
export function getSellerAddress(address) {
  // console.log('address = ' + address);
  if (!address) {
    return '';
  }
  if (address.indexOf('县') >= 0) {
    return address.split('县')[0] + '县';
  } else if (address.indexOf('区') >= 0) {
    return address.split('区')[0] + '区';
  } else if (address.indexOf('市') >= 0) {
    let add_list = address.split('市');
    if (add_list.length === 1) {
      return add_list[0] + '市';
    } else {
      let return_add = '';
      for (let i = 0; i < add_list.length; i++) {
        if (i !== add_list.length - 1) {
          return_add += add_list[i] + '市';
        }
      }
      return return_add;
    }
  } else {
    return address;
  }
}

export function getAges(str) {
  var returnAge;
  var strBirthdayArr = str.split('/');
  var birthYear = strBirthdayArr[0];
  var birthMonth = strBirthdayArr[1];
  var birthDay = strBirthdayArr[2];
  var d = new Date();
  var nowYear = d.getFullYear();
  var nowMonth = d.getMonth() + 1;
  var nowDay = d.getDate();
  if (nowYear === birthYear) {
    returnAge = 0;
  } else {
    var ageDiff = nowYear - birthYear;
    if (ageDiff > 0) {
      if (nowMonth === birthMonth) {
        var dayDiff = nowDay - birthDay;
        if (dayDiff < 0) {
          returnAge = ageDiff - 1;
        } else {
          returnAge = ageDiff;
        }
      } else {
        var monthDiff = nowMonth - birthMonth;
        if (monthDiff < 0) {
          returnAge = ageDiff - 1;
        } else {
          returnAge = ageDiff;
        }
      }
    } else {
      returnAge = 0;
    }
  }
  return returnAge;
}

export const convertDateFromString = function(dateString) {
  if (dateString) {
    let arr1 = dateString.split(' ');
    let sdate = arr1[0].split('-');
    let sSecond = arr1[1].split(':');
    let date = new Date(sdate[0], sdate[1] - 1, sdate[2], sSecond[0], sSecond[1]);
    return date;
  }
};

export const formatDuring = function(ss) {
  let days = parseInt(ss / (60 * 60 * 24));
  let hours = parseInt((ss % (60 * 60 * 24)) / (60 * 60));
  let minutes = parseInt((ss % (60 * 60)) / 60);
  let resStr = '';
  let isDay = false;
  if (days > 0) {
    resStr += days + ' 天 ';
    isDay = true;
  }
  if (isDay || hours > 0) {
    resStr += hours + ' 时 ';
  }
  resStr += minutes + ' 分';
  return resStr;
};

export const dateTimeFormat = function(date, fmt = 'yyyy-MM-dd hh:mm:ss') {
  if (typeof date === 'string') {
    return date;
  }
  let o = {
    'M+': date.getMonth() + 1, // 月份
    'd+': date.getDate(), // 日
    'h+': date.getHours(), // 小时
    'm+': date.getMinutes(), // 分
    's+': date.getSeconds(), // 秒
    'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
    S: date.getMilliseconds() // 毫秒
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
  }
  for (let k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
    }
  }
  let nowDate = new Date().getDate();
  // console.log('nowDate', nowDate);
  if (nowDate === o['d+']) {
    let arr = fmt.split(' ');
    return '今日 ' + arr[1];
  }
  return fmt;
};

export const dateFormat = function(date, fmt = 'yyyy-MM-dd') {
  if (typeof date === 'string') {
    return date;
  }
  let o = {
    'M+': date.getMonth() + 1, // 月份
    'd+': date.getDate() // 日
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
  }
  for (let k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
    }
  }
  return fmt;
};

export const distanceDisplay = function(distance) {
  if (distance <= 0) {
    return (Math.round(distance * 10) / 10).toFixed(1) + ' 公里';
  } else if (distance > 0 && distance < 1) {
    return Math.round(distance * 1000).toFixed(0) + ' 米';
  } else if (distance >= 1 && distance <= 50) {
    return (Math.round(distance * 10) / 10).toFixed(1) + ' 公里';
  } else {
    // return (Math.round(distance / 100) / 10).toFixed(1) + 'k 公里';
    return '>50公里';
  }
};

export const getWeekDay = function(date, prefix = '星期') {
  if (typeof date === 'string') {
    date = date.replace(/-/g, '/');
    date = new Date(date);
  }
  let day = date.getDay();
  let weekday = ['日', '一', '二', '三', '四', '五', '六'];
  return prefix + weekday[day];
};

export const getWeekDayNum = function(date) {
  if (typeof date === 'string') {
    date = date.replace(/-/g, '/');
    date = new Date(date);
  }
  let day = date.getDay();
  let weekday = [0, 1, 2, 3, 4, 5, 6];
  return weekday[day];
};

export const getInterviewTimeStr = function(date) {
  if (typeof date === 'string') {
    date = date.replace(/-/g, '/');
    date = new Date(date);
  }
  let name1 = '';
  let name2 = dateFormat(date, 'yyyy-MM-dd');
  name1 = convertTimeToDayTT(dateFormat(date, 'yyyy-MM-dd hh:mm:ss'));
  if (name1.length === 0) {
    name1 = checkInSameWeek(dateFormat(date, 'yyyy-MM-dd hh:mm:ss'));
    name1 = name1 + getWeekDay(date, '周');
  }
  return name1 + name2;
};

export const getInterviewDayStr = function(date) {
  if (typeof date === 'string') {
    date = date.replace(/-/g, '/');
    date = new Date(date);
  }
  let name1 = '';
  let name2 = dateFormat(date, 'MM-dd');
  name1 = convertTimeToDayTT(dateFormat(date, 'yyyy-MM-dd hh:mm:ss'));
  if (name1.length === 0) {
    name1 = checkInSameWeek(dateFormat(date, 'yyyy-MM-dd hh:mm:ss'));
    name1 = name1 + getWeekDay(date, '周');
  }
  return name1 + name2.split('-')[0] + '月' + name2.split('-')[1] + '日';
};

export const getWorkDateStr = function(list) {
  if (!list || !list.length) {
    return '';
  }
  let checkedDateList = [];
  list.map(item => {
    switch (item.DayOfWeek) {
      case 1:
        checkedDateList.push('星期一');
        break;
      case 2:
        checkedDateList.push('星期二');
        break;
      case 3:
        checkedDateList.push('星期三');
        break;
      case 4:
        checkedDateList.push('星期四');
        break;
      case 5:
        checkedDateList.push('星期五');
        break;
      case 6:
        checkedDateList.push('星期六');
        break;
      case 7:
        checkedDateList.push('做一休一');
        break;
      case 8:
        checkedDateList.push('做二休二');
        break;
      case 9:
        checkedDateList.push('做二休一');
        break;
      case 10:
        checkedDateList.push('做六休一');
        break;
      case 0:
        checkedDateList.push('星期日');
        break;
    }
  });
  let tmpArr = ['星期一', '星期二', '星期三', '星期四', '星期五', '星期六', '星期日'];
  let tmpArrRes = [];
  for (let i = 0; i < tmpArr.length; i++) {
    let day = tmpArr[i];
    let index = checkedDateList.indexOf(day);
    if (index >= 0) {
      tmpArrRes.push(day);
      checkedDateList.splice(index, 1);
    }
  }
  if (checkedDateList.length > 0) {
    tmpArrRes = tmpArrRes.concat(checkedDateList);
  }
  let sixIndex = tmpArrRes.indexOf('星期六');
  let sevenIndex = tmpArrRes.indexOf('星期日');
  let listLen = tmpArrRes.length;
  if (listLen === 5 && sixIndex === -1 && sevenIndex === -1) {
    return '工作日';
  } else if (listLen === 7 && sixIndex !== -1 && sevenIndex !== -1) {
    return '工作日 双休日';
  } else if (listLen === 2 && sixIndex !== -1 && sevenIndex !== -1) {
    return '双休日';
  } else {
    if (sixIndex !== -1 && sevenIndex !== -1) {
      tmpArrRes.splice(sixIndex, 1);
      sevenIndex = tmpArrRes.indexOf('星期日');
      tmpArrRes.splice(sevenIndex, 1);
      return tmpArrRes.join(' ') + ' 双休日';
    } else if (listLen === 6 && sixIndex !== -1) {
      return '工作日 星期六';
    } else if (listLen === 6 && sevenIndex !== -1) {
      return '工作日 星期日';
    } else {
      return tmpArrRes.join(' ');
    }
  }
};

export const getWorkDayAreaStr = function(list) {
  if (list && list.length) {
    let tmpStart = list[0].StartTime.split(' ')[0];
    let tmpEnd = list[0].EndTime.split(' ')[0];
    let str = tmpStart + ' ~ ' + tmpEnd;
    return str;
  } else {
    return '';
  }
};

export const getInterviewDateFilter = function() {
      let pickTimeList = [];
      let index = 0;
      for (let j = 0; j < 7; j++) {
        let obj = {
          value: j
        };
        let labelDate = getDateAfterDays(index);
        let date = labelDate.replace(/-/g, '/');
        date = new Date(date);
        let name1 = '';
        let name2 = dateFormat(date, 'MM-dd');
        name1 = convertTimeToDayTT(dateFormat(date, 'yyyy-MM-dd hh:mm:ss'));
        if (name1.length === 0) {
          name1 = checkInSameWeek(dateFormat(date, 'yyyy-MM-dd hh:mm:ss'));
          if (name1.length > 0) {
            name1 = getWeekDay(date, '周');
          }
        }
        // (${getWeekDay(labelDate, '周')})
        if (name1.length > 0) {
          obj.label = name1 + '可面';
        } else {
          obj.label = name2 + '可面';
        }
        // obj.label = `${labelDate.substring(5, 10)}`;
        obj.weekday = getWeekDayNum(labelDate);
        pickTimeList.push(obj);
        if (checkInSameWeek(labelDate)) { // 与今天处于同一周则继续
          j--;
        }
        index++;
      }
      return pickTimeList;
};

export const getShopInterviewTimeList = function(list) {
  if (list && list.length) {
    if (list.length >= 2) {
      let viewTimeSlot1 = list[0];
      let viewTimeSlot2 = list[1];
      let viewTimeSlot1StartDate = viewTimeSlot1.StartDate.substring(10);
      let viewTimeSlot1EndDate = viewTimeSlot1.EndDate.substring(10);
      let viewTimeSlot2StartDate = viewTimeSlot2.StartDate.substring(10);
      let viewTimeSlot2EndDate = viewTimeSlot2.EndDate.substring(10);
      return viewTimeSlot1StartDate.substring(0, 6) + '~' + viewTimeSlot1EndDate.substring(0, 6) + ' |' + viewTimeSlot2StartDate.substring(0, 6) + '~' + viewTimeSlot2EndDate.substring(0, 6);
    } else {
      let viewTimeSlot1 = list[0];
      let viewTimeSlot1StartDate = viewTimeSlot1.StartDate.substring(10);
      let viewTimeSlot1EndDate = viewTimeSlot1.EndDate.substring(10);
      return viewTimeSlot1StartDate.substring(0, 6) + '~' + viewTimeSlot1EndDate.substring(0, 6);
    }
  } else {
    return [];
  }
};

// 解析面试时间
export const getShopInterviewFilterDateList = function(list, filtList) {
  if (list && list.length) {
    let now = new Date();
    let nowStr = dateFormat(now);
    let nowTime = now.getTime();
    if (list.length >= 2) {
      let viewTimeSlot1 = list[0];
      let viewTimeSlot2 = list[1];
      viewTimeSlot1.StartDate = nowStr + viewTimeSlot1.StartDate.substring(10);
      viewTimeSlot1.EndDate = nowStr + viewTimeSlot1.EndDate.substring(10);
      viewTimeSlot2.StartDate = nowStr + viewTimeSlot2.StartDate.substring(10);
      viewTimeSlot2.EndDate = nowStr + viewTimeSlot2.EndDate.substring(10);
      let timeSlotStartDate1 = toDate(viewTimeSlot1.StartDate).getTime();
      let timeSlotEndDate2 = toDate(viewTimeSlot2.EndDate).getTime() - 2 * 3600 * 1000;
      let pickTimeList = [];
      let startIndex = 0;
      let endIndex = 6;
      if (nowTime >= timeSlotEndDate2) {
        startIndex = 1;
        endIndex = 7;
      }
      let tempIndex = startIndex;
      for (let j = startIndex; j < endIndex; j++) {
        let obj = {
          value: j,
          children: []
        };
        // let labelDate = getDateAfterDays(j);
        let labelDate = getDateAfterDays(tempIndex);
        if (filtList && filtList.length > 0 && filtList.indexOf(getWeekDayNum(labelDate)) === -1) {
            tempIndex++;
            j--;
            continue;
        }
        obj.label = `${labelDate.substring(5, 10)}(${getWeekDay(labelDate, '周')})`;
        let timeList = [];
        if (j === startIndex && startIndex === 0 && nowTime >= timeSlotStartDate1) {
          let startDate = nowTime + 3600 * 1000;
          let tempTimeList = [
            ...toDateTimeList(viewTimeSlot1.StartDate, viewTimeSlot1.EndDate),
            ...toDateTimeList(viewTimeSlot2.StartDate, viewTimeSlot2.EndDate)
          ];
          for (let time of tempTimeList) {
            let str = nowStr + ' ' + time;
            if (startDate < toDate(str).getTime()) {
              timeList.push(time);
            }
          }
        } else {
          timeList = [
            ...toDateTimeList(viewTimeSlot1.StartDate, viewTimeSlot1.EndDate),
            ...toDateTimeList(viewTimeSlot2.StartDate, viewTimeSlot2.EndDate)
          ];
        }
        for (let s = 0; s < timeList.length; s++) {
          let times = timeList[s];
          let childObj = {
            label: times.substring(0, 5),
            value: s
          };
          obj.children.push(childObj);
        }
        pickTimeList.push(obj);
        tempIndex++;
      }
      return pickTimeList;
    } else {
      // console.log('getShopInterviewDateList-length=1');
      let viewTimeSlot1 = list[0];
      viewTimeSlot1.StartDate = nowStr + viewTimeSlot1.StartDate.substring(10);
      // console.log(viewTimeSlot1.StartDate);
      viewTimeSlot1.EndDate = nowStr + viewTimeSlot1.EndDate.substring(10);
      // console.log(viewTimeSlot1.EndDate);
      let timeSlotStartDate1 = toDate(viewTimeSlot1.StartDate).getTime();
      // console.log(timeSlotStartDate1);
      let timeSlotEndDate1 = toDate(viewTimeSlot1.EndDate).getTime() - 2 * 3600 * 1000;
      // console.log(timeSlotEndDate1);
      let pickTimeList = [];
      let startIndex = 0;
      let endIndex = 6;
      if (nowTime >= timeSlotEndDate1) {
        startIndex = 1;
        endIndex = 7;
      }
      let tempIndex = startIndex;
      for (let j = startIndex; j < endIndex; j++) {
        let obj = {
          value: j,
          children: []
        };
        let labelDate = getDateAfterDays(tempIndex);
        if (filtList && filtList.length > 0 && filtList.indexOf(getWeekDayNum(labelDate)) === -1) {
          tempIndex++;
          j--;
          continue;
        }
        obj.label = `${labelDate.substring(5, 10)}(${getWeekDay(labelDate, '周')})`;
        let timeList = [];
        if (tempIndex === startIndex && startIndex === 0 && nowTime >= timeSlotStartDate1) {
          let startDate = nowTime + 3600 * 1000;
          let tempTimeList = [...toDateTimeList(viewTimeSlot1.StartDate, viewTimeSlot1.EndDate)];
          for (let time of tempTimeList) {
            let str = nowStr + ' ' + time;
            if (startDate < toDate(str).getTime()) {
              timeList.push(time);
            }
          }
        } else {
          timeList = [...toDateTimeList(viewTimeSlot1.StartDate, viewTimeSlot1.EndDate)];
        }
        for (let s = 0; s < timeList.length; s++) {
          let times = timeList[s];
          let childObj = {
            label: times.substring(0, 5),
            value: s
          };
          obj.children.push(childObj);
        }
        pickTimeList.push(obj);
        tempIndex++;
      }
      return pickTimeList;
    }
  } else {
    return [];
  }
};

export const getInterviewDateStr = function(list) {
  if (!list || !list.length) {
    return [];
  }
  let checkedDateList = [];
  list.map(item => {
    switch (item) {
      case 1:
        checkedDateList.push({ 'val': '星期一' });
        break;
      case 2:
        checkedDateList.push({ 'val': '星期二' });
        break;
      case 3:
        checkedDateList.push({ 'val': '星期三' });
        break;
      case 4:
        checkedDateList.push({ 'val': '星期四' });
        break;
      case 5:
        checkedDateList.push({ 'val': '星期五' });
        break;
      case 6:
        checkedDateList.push({ 'val': '星期六' });
        break;
      case 0:
        checkedDateList.push({ 'val': '星期日' });
        break;
    }
  });
  return checkedDateList;
};

export const getWorkTimeStr = function(list) {
  if (list && list.length) {
    let tmpStartArr = list[0].StartTime.split(' ');
    let tmpEndArr = list[0].EndTime.split(' ');
    let tmpStartArr2 = tmpStartArr[1].split(':');
    let tmpEndArr2 = tmpEndArr[1].split(':');
    let startTime = tmpStartArr2[0] + ':' + tmpStartArr2[1];
    let endTime = tmpEndArr2[0] + ':' + tmpEndArr2[1];
    let str = startTime + '-' + endTime;
    const WorkTimeType = require('../libs/config').WorkTimeType;
    return [str, WorkTimeType[list[0].WorkTimeType]];
  } else {
    return [];
  }
};

export const toDate = function(str) {
  let dateTime = str.split(' ');
  let _date = dateTime[0].split('-');
  let _time = dateTime[1].split(':');
  return new Date(
    parseInt(_date[0]),
    parseInt(_date[1]) - 1,
    parseInt(_date[2]),
    parseInt(_time[0]),
    parseInt(_time[1]),
    parseInt(_time[2])
  );
};

export const toDateTimeList = function(startDate, endDate) {
  let endTime = toDate(endDate).getTime();
  let startTime = toDate(startDate).getTime();
  // console.log(endTime);
  // console.log(startTime);
  // console.log((endTime - startTime));
  let mins = Math.floor((endTime - startTime) / 1000 / 60 / 30);
  // console.log(mins);
  let dateTime = startDate.split(' ');
  // let _date = dateTime[0].split("-");
  let _time = dateTime[1].split(':');
  let _hour = _time[0] - 0;
  let _min = _time[1] - 0;
  let list = [];
  for (let i = 0; i <= mins; i++) {
    let ke = 30 * i;
    let _ke2 = parseInt((_min + ke) / 60);
    if ((_min + ke) % 60 === 0) {
      list.push(`${('0' + (_hour + _ke2)).slice(-2)}:00:00`);
    } else {
      list.push(`${('0' + (_hour + _ke2)).slice(-2)}:30:00`);
    }
  }
  return list;
};

export const getDateAfterDays = function(AddDayCount) {
  let dd = new Date();
  dd.setDate(dd.getDate() + AddDayCount);
  let y = dd.getFullYear();
  let m = dd.getMonth() + 1 < 10 ? '0' + (dd.getMonth() + 1) : dd.getMonth() + 1;
  let d = dd.getDate() < 10 ? '0' + dd.getDate() : dd.getDate();
  return y + '-' + m + '-' + d;
};

export const getPickCount = function(successCount, pickCount) {
  let num = pickCount.toString();
  let num2 = num.substring(num.length - 2);
  return parseInt(num2) + 300 + successCount;
};

// 判断时间为今天，昨天
export const convertTimeToDay = function(dateStr) {
  let date = dateStr.split(' ')[0];
  let _date = date.split('-');
  let d1 = new Date(_date[0] + '/' + _date[1] + '/' + _date[2]);
  let dd = new Date();
  let y = dd.getFullYear();
  let m = dd.getMonth() + 1;
  let d = dd.getDate();
  let d2 = new Date(y + '/' + m + '/' + d);
  let iday = parseInt(d2 - d1) / 1000 / 60 / 60 / 24;
  if (iday === 0) {
    return '今天';
  } else if (iday === 1) {
    return '昨天';
  } else {
    return date;
  }
};

// 判断时间为今天，明天
export const convertTimeToDayTT = function(dateStr) {
  let date = dateStr.split(' ')[0];
  let _date = date.split('-');
  let d1 = new Date(_date[0] + '/' + _date[1] + '/' + _date[2]);
  let dd = new Date();
  let y = dd.getFullYear();
  let m = dd.getMonth() + 1;
  let d = dd.getDate();
  let d2 = new Date(y + '/' + m + '/' + d);
  let iday = parseInt(d2 - d1) / 1000 / 60 / 60 / 24;
  if (iday === 0) {
    return '今天';
  } else if (iday === -1) {
    return '明天';
  } else {
    return '';
  }
};

// 判断是否是本周
export const checkInSameWeek = function(dateStr) {
  let date = dateStr.split(' ')[0];
  let _date = date.split('-');
  let d1 = new Date(_date[0] + '/' + _date[1] + '/' + _date[2]);
  let dd = new Date();
  let y = dd.getFullYear();
  let m = dd.getMonth() + 1;
  let d = dd.getDate();
  let d2 = new Date(y + '/' + m + '/' + d);
  let oneDayTime = 1000 * 60 * 60 * 24;
  let old_count = parseInt(d1.getTime() / oneDayTime);
  let now_other = parseInt(d2.getTime() / oneDayTime);
  if (parseInt((old_count + 4) / 7) === parseInt((now_other + 4) / 7)) {
    return '本';
  } else {
    return '';
  }
};

export function scrollTop(el, from = 0, to, duration = 500) {
  if (!window.requestAnimationFrame) {
    window.requestAnimationFrame = (
      window.webkitRequestAnimationFrame ||
      window.mozRequestAnimationFrame ||
      window.msRequestAnimationFrame ||
      function(callback) {
        return window.setTimeout(callback, 60000 / 60);
      }
    );
  }
  const difference = Math.abs(from - to);
  const step = Math.ceil(difference / duration * 20 + 1);

  function scroll(start, end, step) {
    if (start === end) return;
    let d = (start + step > end) ? end : start + step;
    if (start > end) {
      d = (start - step < end) ? end : start - step;
    }
    if (el === window) {
      window.scrollTo(d, d);
    } else {
      el.scrollTop = d;
    }
    window.requestAnimationFrame(() => scroll(d, end, step));
  }

  scroll(from, to, step);
}

export function convertBase64ToBlob(base64) {
  let base64Arr = base64.split(',');
  let imgtype = 'image/jpeg'; // 默认类型
  let base64String = '';
  
  if (base64Arr.length > 1) {
    // 带前缀格式：data:image/jpeg;base64,xxxxx
    base64String = base64Arr[1];
    imgtype = base64Arr[0].substring(base64Arr[0].indexOf(':') + 1, base64Arr[0].indexOf(';'));
  } else {
    // 纯 base64 字符串，没有前缀
    base64String = base64;
  }

  let bytes = atob(base64String);
  let bytesCode = new ArrayBuffer(bytes.length);
  let byteArray = new Uint8Array(bytesCode);
  for (let i = 0; i < bytes.length; i++) {
    byteArray[i] = bytes.charCodeAt(i);
  }
  return new Blob([bytesCode], { type: imgtype });
}

/**
 * 压缩Base64图片
 * @param {string} base64 - base64图片字符串（可带前缀或不带）
 * @param {Object} options - 压缩配置
 * @param {number} options.maxWidth - 最大宽度，默认1200
 * @param {number} options.maxHeight - 最大高度，默认1200
 * @param {number} options.quality - 压缩质量 0-1，默认0.8
 * @param {number} options.maxSize - 最大文件大小（KB），默认500
 * @returns {Promise<string>} 压缩后的base64字符串（不带前缀）
 */
export function compressBase64Image(base64, options = {}) {
  const {
    maxWidth = 1200,
    maxHeight = 1200,
    quality = 0.8,
    maxSize = 500 // KB
  } = options;

  return new Promise((resolve, reject) => {
    try {
      // 确保有完整的 data URL 前缀
      let imgSrc = base64;
      if (!base64.startsWith('data:')) {
        imgSrc = 'data:image/jpeg;base64,' + base64;
      }

      const img = new Image();
      img.onload = () => {
        let width = img.width;
        let height = img.height;

        // 计算缩放比例
        if (width > maxWidth || height > maxHeight) {
          const ratio = Math.min(maxWidth / width, maxHeight / height);
          width = Math.round(width * ratio);
          height = Math.round(height * ratio);
        }

        // 创建canvas
        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');
        
        // 绘制白色背景（防止透明图片变黑）
        ctx.fillStyle = '#FFFFFF';
        ctx.fillRect(0, 0, width, height);
        
        // 绘制图片
        ctx.drawImage(img, 0, 0, width, height);

        // 递归压缩直到满足大小要求
        let currentQuality = quality;
        const compress = () => {
          const compressedBase64 = canvas.toDataURL('image/jpeg', currentQuality);
          // 移除前缀，只返回纯base64字符串
          const pureBase64 = compressedBase64.split(',')[1];
          
          // 计算大小 (base64 字符串长度 * 0.75 ≈ 实际字节数)
          const sizeKB = (pureBase64.length * 0.75) / 1024;
          
          if (sizeKB > maxSize && currentQuality > 0.3) {
            // 继续压缩
            currentQuality -= 0.1;
            compress();
          } else {
            console.log(`图片压缩完成: ${Math.round(sizeKB)}KB, quality: ${currentQuality.toFixed(1)}, size: ${width}x${height}`);
            resolve(pureBase64);
          }
        };

        compress();
      };

      img.onerror = (e) => {
        console.error('图片加载失败:', e);
        // 加载失败时返回原图
        const pureBase64 = base64.includes(',') ? base64.split(',')[1] : base64;
        resolve(pureBase64);
      };

      img.src = imgSrc;
    } catch (e) {
      console.error('图片压缩失败:', e);
      // 出错时返回原图
      const pureBase64 = base64.includes(',') ? base64.split(',')[1] : base64;
      resolve(pureBase64);
    }
  });
}

